function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M12.3822 0.785556C12.2267 0.326667 11.7911 0 11.2778 0H2.72222C2.20889 0 1.78111 0.326667 1.61778 0.785556L0 5.44444V11.6667C0 12.0944 0.35 12.4444 0.777778 12.4444H1.55556C1.98333 12.4444 2.33333 12.0944 2.33333 11.6667V10.8889H11.6667V11.6667C11.6667 12.0944 12.0167 12.4444 12.4444 12.4444H13.2222C13.65 12.4444 14 12.0944 14 11.6667V5.44444L12.3822 0.785556ZM2.99446 1.55556H10.9978L11.8378 3.97444H2.15446L2.99446 1.55556ZM1.55556 9.33333H12.4444V5.44444H1.55556V9.33333ZM3.5 6.22222C2.85567 6.22222 2.33333 6.74456 2.33333 7.38889C2.33333 8.03322 2.85567 8.55556 3.5 8.55556C4.14433 8.55556 4.66667 8.03322 4.66667 7.38889C4.66667 6.74456 4.14433 6.22222 3.5 6.22222ZM9.33333 7.38889C9.33333 6.74456 9.85567 6.22222 10.5 6.22222C11.1443 6.22222 11.6667 6.74456 11.6667 7.38889C11.6667 8.03322 11.1443 8.55556 10.5 8.55556C9.85567 8.55556 9.33333 8.03322 9.33333 7.38889Z",
  fill: "#121221"
});

function SvgAutomotiveTiny(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 13,
    viewBox: "0 0 14 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAutomotiveTiny);
export default __webpack_public_path__ + "static/media/AutomotiveTiny.1eb871c8.svg";
export { ForwardRef as ReactComponent };